import { render, staticRenderFns } from "./CreateAdminLogin.vue?vue&type=template&id=92233600"
import script from "./CreateAdminLogin.vue?vue&type=script&lang=ts"
export * from "./CreateAdminLogin.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports